// data/vehicleTypes.ts

export type VehicleTypeKey =
  | "personal"
  | "government"
  | "police"
  | "taxi"
  | "sepah"
  | "mod" // Ministry of Defense
  | "disabled"
  | "army"
  | "public"
  | "armedForces"
  | "agriculture"
  | "temporary"
  | "diplomatic"
  | "freeZone";

interface VehicleTypeInfo {
  title: string; // فارسی
  description: string; // فارسی
  color: string;
  textColor?: string;
}

export const vehicleTypes: Record<VehicleTypeKey, VehicleTypeInfo> = {
  personal: {
    title: "پلاک خودروهای شخصی",
    description:
      "این پلاک‌ها برای افراد حقیقی صادر می‌شوند و زمینه سفید با نوشته‌های مشکی دارند. شامل کد استان، حرف شهر، سه رقم و کد منطقه هستند.",
    color: "bg-white",
  },
  government: {
    title: "پلاک خودروهای دولتی",
    description:
      "دارای زمینه قرمز و نوشته‌های سفید هستند. این پلاک‌ها برای ادارات و سازمان‌های دولتی صادر می‌شوند.",
    color: "bg-red-800",
    textColor: "text-white",
  },
  police: {
    title: "پلاک خودروهای پلیس",
    description:
      "با زمینه سبز و نوشته‌های سفید، ویژه خودروهای نیروی انتظامی (ناجا) هستند و فقط برای وسایل نقلیه رسمی پلیس صادر می‌شوند.",
    color: "bg-green-900",
    textColor: "text-white",
  },
  taxi: {
    title: "پلاک تاکسی",
    description:
      "پلاک‌های زرد با حرف «ت» که ویژه ناوگان تاکسیرانی هستند و شامل نشان TAXI در بالای حرف پلاک هستند.",
    color: "bg-yellow-300",
  },
  sepah: {
    title: "پلاک خودروهای سپاه",
    description:
      "دارای زمینه سبز و نوشته‌های سفید. برای وسایل نقلیه وابسته به سپاه پاسداران صادر می‌شوند.",
    color: "bg-green-900",
    textColor: "text-white",
  },
  mod: {
    title: "پلاک وزارت دفاع",
    description:
      "دارای زمینه آبی فیروزه‌ای و نوشته سفید. برای خودروهای وابسته به وزارت دفاع و پشتیبانی نیروهای مسلح صادر می‌شوند.",
    color: "bg-cyan-700",
    textColor: "text-white",
  },
  disabled: {
    title: "پلاک معلولین و جانبازان",
    description:
      "مشابه پلاک شخصی است با این تفاوت که به جای حرف، نشان مخصوص معلولین درج می‌شود تا قابل تشخیص باشند.",
    color: "bg-white",
  },
  army: {
    title: "پلاک خودروهای ارتش",
    description:
      "با زمینه خاکی و نوشته‌های مشکی. ویژه وسایل نقلیه متعلق به ارتش جمهوری اسلامی ایران است.",
    color: "bg-orange-200",
  },
  public: {
    title: "پلاک خودروهای عمومی",
    description:
      "برای وسایل حمل‌ونقل عمومی مثل اتوبوس، مینی‌بوس و وانت صادر می‌شود. زمینه زرد و نوشته‌های مشکی دارد.",
    color: "bg-yellow-300",
  },
  armedForces: {
    title: "پلاک ستاد کل نیروهای مسلح",
    description:
      "ویژه خودروهای ستاد کل نیروهای مسلح. دارای زمینه آبی فیروزه‌ای و نوشته سفید است.",
    color: "bg-cyan-700",
    textColor: "text-white",
  },
  agriculture: {
    title: "پلاک خودروهای کشاورزی",
    description:
      "برای وسایل نقلیه کشاورزی مانند تراکتورها صادر می‌شود. زمینه زرد با نوشته مشکی دارد.",
    color: "bg-yellow-300",
  },
  temporary: {
    title: "پلاک گذرموقت",
    description:
      "برای خودروهایی که به‌صورت موقت وارد کشور می‌شوند صادر شده و طراحی ویژه‌ای برای تمایز دارند.",
    color: "bg-white",
  },
  diplomatic: {
    title: "سیاسی / تشریفات",
    description:
      "ویژه خودروهای سفارت‌ها و مأموران دیپلماتیک. این پلاک‌ها از معافیت گمرکی برخوردارند.",
    color: "bg-red-800",
    textColor: "text-white",
  },
  freeZone: {
    title: "پلاک مناطق آزاد تجاری",
    description:
      "با طراحی مستطیلی شبیه به استاندارد آمریکایی، برای خودروهای مناطق آزاد تجاری صادر می‌شود و شامل لوگو و کد منطقه است.",
    color: "bg-white",
  },
};
export const plateAlphabetMap: Record<string, VehicleTypeKey> = {
  ب: "personal",
  ج: "personal",
  د: "personal",
  س: "personal",
  ل: "personal",
  ق: "personal",
  ص: "personal",
  ط: "personal",
  م: "personal",
  ن: "personal",
  و: "personal",
  ه: "personal",
  ی: "personal",
  "الف (دولتی)": "government",
  "پ (پلیس)": "police",
  "ت (تاکسی)": "taxi",
  "ث (سپاه)": "sepah",
  "ز (وزارت دفاع)": "mod",
  "ش (ارتش)": "army",
  "ع (عمومی)": "public",
  "ف (نیروهای مسلح)": "armedForces",
  "ک (کشاورزی)": "agriculture",
  "گ (گذرموقت)": "temporary",
  "ژ (معلولین)": "disabled",
  تشریفات: "diplomatic",
  "D (سیاسی)": "diplomatic",
  " (سیاسی) S": "diplomatic",
};
